import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
// Models
import mBooking from 'models/cpm/booking';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import {
  listFeatureSearchFieldShape,
  listFilterShape,
} from 'constants/PropTypesShapes';
import { dateGenerator } from 'utils/DateUtils';
import { toLowerOrNull, toUpperOrNull } from 'utils/Tools';
// Components
import FiltersCardTemplate from 'components/templates/FiltersCardTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import ItemsSelectFieldFilter from 'components/filters/ItemsSelectFieldFilter';
import DateFilter from 'components/filters/DateFilter';

const MyBookingFilters = ({
  timezone,
  disabled,
  advanced,
  nbFiltersApplied,
  searchFields,
  field,
  filters,
  isFieldDisplayable,
  onFieldChange,
  onFilterFieldChange,
  onReinit,
  onSwitch,
}) => {
  const {
    status, beginBefore, beginAfter, endBefore, endAfter,
  } = filters;
  // Dates
  const beginAfterDate = dateGenerator.dateFromTimezone(
    beginAfter.value,
    timezone,
  );
  const beginBeforeDate = dateGenerator.dateFromTimezone(
    beginBefore.value,
    timezone,
  );
  const endAfterDate = dateGenerator.dateFromTimezone(endAfter.value, timezone);
  const endBeforeDate = dateGenerator.dateFromTimezone(
    endBefore.value,
    timezone,
  );

  return (
    <div className="mb-3">
      <FiltersCardTemplate
        disabled={disabled}
        advanced={advanced}
        nbFiltersApplied={nbFiltersApplied}
        onReinit={onReinit}
        onSwitch={onSwitch}
        defaultBackground={false}
      >
        <React.Fragment>
          {!advanced && (
            <div className="col-12 col-md-4 col-xl-3">
              <BaseListFilter
                field={field}
                searchFields={searchFields}
                onChange={onFieldChange}
              />
            </div>
          )}
          {isFieldDisplayable('status') && (
            <div className="col-12 col-md-4 col-xl-3">
              <ItemsSelectFieldFilter
                labelId="field.status"
                value={toLowerOrNull(status.value)}
                items={mBooking.bookingStatusList}
                onChange={(value) => onFilterFieldChange('status', toUpperOrNull(value))}
              />
            </div>
          )}
          {isFieldDisplayable('beginAfter') && (
            <div className="col-12 col-md-4 col-xl-3">
              <DateFilter
                labelId="field.afterDateBegin"
                timezone={timezone}
                type="begin"
                value={beginAfterDate}
                onChange={(value) => onFilterFieldChange('beginAfter', value)}
              />
            </div>
          )}
          {isFieldDisplayable('beginBefore') && (
            <div className="col-12 col-md-4 col-xl-3">
              <DateFilter
                labelId="field.beforeDateBegin"
                timezone={timezone}
                type="end"
                value={beginBeforeDate}
                onChange={(value) => onFilterFieldChange('beginBefore', value)}
              />
            </div>
          )}
          {isFieldDisplayable('endAfter') && (
            <div className="col-12 col-md-4 col-xl-3">
              <DateFilter
                labelId="field.afterDateEnd"
                timezone={timezone}
                type="begin"
                value={endAfterDate}
                onChange={(value) => onFilterFieldChange('endAfter', value)}
              />
            </div>
          )}
          {isFieldDisplayable('endBefore') && (
            <div className="col-12 col-md-4 col-xl-3">
              <DateFilter
                labelId="field.beforeDateEnd"
                timezone={timezone}
                type="end"
                value={endBeforeDate}
                onChange={(value) => onFilterFieldChange('endBefore', value)}
              />
            </div>
          )}
        </React.Fragment>
      </FiltersCardTemplate>
    </div>
  );
};

MyBookingFilters.propTypes = {
  timezone: PropTypes.string.isRequired,
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    status: listFilterShape,
    beginAfter: listFilterShape,
    beginBefore: listFilterShape,
    endAfter: listFilterShape,
    endBefore: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = compose(
  wrapListFilters(mBooking.listFeatures.searchFields),
)(MyBookingFilters);



// WEBPACK FOOTER //
// ./routes/my_bookings/assets/MyBookingFilters.js